import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

import { NotificationState } from '@/store/notifications/notification'
import {
  createReportTemplate,
  deleteReportTemplate,
  updateReportTemplate,
} from '@/store/report-templates/thunks'

export function reportTemplatesCases(builder: ActionReducerMapBuilder<NotificationState>) {
  builder
    .addCase(createReportTemplate.fulfilled, (state, { payload: { reportTemplate } }) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xCreated',
        descriptionTransOptions: { value: reportTemplate.name },
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(updateReportTemplate.fulfilled, (state, { payload: { reportTemplate } }) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'xUpdated',
        descriptionTransOptions: { value: reportTemplate.name },
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(
      deleteReportTemplate.fulfilled,
      (
        state,
        {
          meta: {
            arg: { reportTemplate },
          },
        },
      ) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xDeleted',
          descriptionTransOptions: { value: reportTemplate.name },
          icon: 'check',
          id: generateId(),
        })
      },
    )
}
